import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { docsUrl } from '../../services/docs';


function HelpButton({ docPath = '', tooltip = "Documentation", size = "small", sx = {} }) {
  return (
    <Tooltip title={tooltip} arrow placement="top">
      <IconButton
        size={size}
        component="a"
        href={docsUrl(docPath)}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: 'text.secondary',
          '&:hover': {
            color: 'text.primary',
            backgroundColor: (theme) =>
              theme.palette.mode === 'dark'
                ? 'rgba(255, 255, 255, 0.05)'
                : 'rgba(0, 0, 0, 0.03)',
          },
          ...sx,
        }}
      >
        <HelpOutlineIcon fontSize={size} />
      </IconButton>
    </Tooltip>
  );
}

export default HelpButton;

